import {
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useHook as InventoryUseHook } from './useHook';
import { ExpandMore } from '@mui/icons-material';
import { useHook as EquipmentsDashboard } from '../hardware/equipments/useHook';
import { useHook as DealerManagementHook } from '../Iam/dealerManagement/useHook';

interface FilterDrawer {
  fliterCloseDrawer: () => void;
  filterSubmit: (data: any) => void;
  filterDrawerData?: any;
  filterPage?: string;
}
interface UserDataList {
  dealerID: string;
  userName: string;
  firstName: string;
  lastName: string;
  avatar: string;
}
const FilterDrawer: React.FC<FilterDrawer> = ({
  fliterCloseDrawer,
  filterSubmit,
  filterDrawerData,
  filterPage,
}) => {
  const userRole = localStorage.getItem('role');
  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fromSerialnumber: filterDrawerData?.serialNumberFrom || '',
      toSerialnumber: filterDrawerData?.serialNumberTo || '',
    },
  });
  const { inventoryFilterList } = useSelector((state: any) => state.inventory);
  const { fetchGetInventoryFilter, fetchGetDealerInventoryFilter } =
    InventoryUseHook();
  const { fetchGetListCategory, fetchDealerGetListCategory } =
    EquipmentsDashboard();
  const { allCategory } = useSelector((state: any) => state.equipments);
  const [equipmentFilter, setEquipmentFilter] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [subCategoryFilter, setSubCategoryFilter] = useState([]);
  const [filterStoreCategory, setFilterStoreCategory] = useState<any[]>([]);
  const [filterStoreSubCategory, setFilterStoreSubCategory] = useState<any[]>(
    [],
  );
  const [gatwayNoFilter, setGatwayNoFilter] = useState([]);
  const [equipmentData, setEquipment] = React.useState<string[]>([]);
  const [categoryData, setCategoryData] = React.useState<string[]>([]);
  const [subCategoryData, setSubCategoryData] = React.useState<string[]>([]);
  const [gatewayNo, setGatewayNo] = React.useState<string[]>([]);
  const [isFilterActive, setFilterActive] = useState(false);
  const fromSerialnumber = watch('fromSerialnumber', '');
  const toSerialnumber = watch('toSerialnumber', '');

  //dealerfilter
  const [filteredData, setFilteredData] = useState<UserDataList[]>([]);
  const [selectedDealerId, setSelectedDealerId] = useState<string[]>([]);
  const { allAssignDealerList } = useSelector((state: any) => state.dealer);
  const { fetchGetAllAssignDealerList } = DealerManagementHook();

  const getDealerData = async () => {
    await fetchGetAllAssignDealerList({});
  };

  useEffect(() => {
    setFilteredData(allAssignDealerList);
  }, [allAssignDealerList]);

  useEffect(() => {
    if(userRole!=="dealer"){
    getDealerData();
    }

  }, []);

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: UserDataList[] = allAssignDealerList?.filter(
      (user: { firstName: any; lastName: any }) =>
        `${user.firstName + user.lastName}`.toLowerCase().includes(query),
    );
    setFilteredData(filtered);
  };

  const handleuser = (userData: any): void => {
    if (selectedDealerId?.includes(userData?.dealerID)) {
      const removedId = selectedDealerId?.filter(
        (item) => item !== userData?.dealerID,
      );
      setSelectedDealerId(removedId);
    } else {
      setSelectedDealerId((pre) => [...pre, userData?.dealerID]);
    }
  };

  const renderSelectedNames = () => {
    const selectedName = allAssignDealerList
      ?.filter((item: { dealerID: string }) =>
        selectedDealerId.includes(item.dealerID),
      )
      ?.map(
        (item: { firstName: any; lastName: any }) =>
          `${item?.firstName || ''} ${item?.lastName || ''}`,
      )
      ?.join(', ');

    return selectedName;
  };

  //get Category
  const handleGetCategory = () => {
    if (userRole === 'dealer') {
      const updateCategory = inventoryFilterList?.category?.map(
        (data: { categoryName: any }) => data?.categoryName,
      );
      setCategoryFilter(updateCategory ? updateCategory : []);
      setFilterStoreCategory(updateCategory ? updateCategory : []);
    } else {
      const updateCategory = allCategory?.map(
        (data: { categoryName: any }) => data?.categoryName,
      );
      setCategoryFilter(updateCategory ? updateCategory : []);
      setFilterStoreCategory(updateCategory ? updateCategory : []);
    }
  };
  //get SubCategory
  const handleGetSubCategory = async () => {
    if (userRole === 'dealer') {
      // Filter based on exact match for the category name
      const upDateSubCategory = inventoryFilterList?.category
        ?.filter(
          (category: { categoryName: any; subCategories: any }) =>
            categoryData.includes(category.categoryName) &&
            Array.isArray(category.subCategories),
        )
        .flatMap((category: { subCategories: any }) => category.subCategories);
      setSubCategoryFilter(upDateSubCategory ? upDateSubCategory : []);
      setFilterStoreSubCategory(upDateSubCategory ? upDateSubCategory : []);

      //subCategory selection values
      const selectSubCategory = upDateSubCategory?.filter((data: string) =>
        subCategoryData?.includes(data),
      );
      setSubCategoryData(selectSubCategory ? selectSubCategory : []);
    } else {
      // Filter based on exact match for the category name
      const upDateSubCategory = allCategory
        .filter(
          (category: { categoryName: any; subCategories: any }) =>
            categoryData.includes(category.categoryName) &&
            Array.isArray(category.subCategories),
        )
        .flatMap((category: { subCategories: any }) => category.subCategories);
      setSubCategoryFilter(upDateSubCategory ? upDateSubCategory : []);
      setFilterStoreSubCategory(upDateSubCategory ? upDateSubCategory : []);

      //subCategory selection values
      const selectSubCategory = upDateSubCategory?.filter((data: string) =>
        subCategoryData?.includes(data),
      );
      setSubCategoryData(selectSubCategory ? selectSubCategory : []);
    }
  };

  useEffect(() => {
    handleGetSubCategory();
  }, [categoryData]);

  useEffect(() => {
    if (allCategory?.length > 0 && userRole !== 'dealer') {
      handleGetCategory();
    }
    if (inventoryFilterList?.category?.length > 0 && userRole === 'dealer') {
      handleGetCategory();
    }
  }, [allCategory, inventoryFilterList]);

  //setSelectionFilter
  useEffect(() => {
    if (filterDrawerData) {
      setEquipment(filterDrawerData?.equipmentModel);
      setCategoryData(filterDrawerData?.category);
      setSubCategoryData(filterDrawerData?.subCategory);
      setGatewayNo(filterDrawerData?.gatewayNo);
      setSelectedDealerId(filterDrawerData?.selectedDealerId);
    }
  }, [filterDrawerData]);

  //getFilter
  const getFilterData = async () => {
    if (userRole === 'dealer') {
      await fetchGetDealerInventoryFilter();
      // if (!(allCategory?.length > 0)) {
      //   fetchDealerGetListCategory({});
      // }
    } else {
      await fetchGetInventoryFilter();
      if (!(allCategory?.length > 0)) {
        fetchGetListCategory({});
      }
    }
  };
  useEffect(() => {
    getFilterData();
  }, []);

  useEffect(() => {
    if (inventoryFilterList) {
      setEquipmentFilter(inventoryFilterList?.equipment);
      setGatwayNoFilter(inventoryFilterList?.gatewayNo);
    }
  }, [inventoryFilterList]);

  //search filter
  const handleSearch = (
    data: any,
    searchValue: string,
    setFilterData: {
      (value: React.SetStateAction<never[]>): void;
      (arg0: any): void;
    },
  ) => {
    const query = searchValue.toLowerCase();
    const filtered = data?.filter((item: string) =>
      item?.toLowerCase().includes(query),
    );
    setFilterData(filtered);
  };

  //selectfilterdata
  const handleFilterSelection = (
    selectName: string | undefined,
    setFilterData: {
      (value: React.SetStateAction<string[]>): void;
      (arg0: (prevselected: any) => any): void;
    },
  ) => {
    if (!selectName) return;
    setFilterData((prevselected) => {
      if (prevselected.includes(selectName)) {
        const updatedData = prevselected.filter(
          (names) => names !== selectName,
        );
        return updatedData;
      } else {
        const updatedData = [...prevselected, selectName];
        return updatedData;
      }
    });
  };

  //activebutton
  useEffect(() => {
    const isFilterActive =
      equipmentData?.length > 0 ||
      categoryData?.length > 0 ||
      subCategoryData?.length > 0 ||
      gatewayNo?.length > 0 ||
      fromSerialnumber?.length > 0 ||
      toSerialnumber?.length > 0 ||
      selectedDealerId?.length > 0;

    setFilterActive(isFilterActive);
  }, [
    equipmentData,
    categoryData,
    subCategoryData,
    gatewayNo,
    fromSerialnumber,
    toSerialnumber,
    selectedDealerId,
  ]);

  //submitfilterdata
  const submitedData = (data: any) => {
    const payload = {
      serialNumberFrom: data.fromSerialnumber,
      serialNumberTo: data.toSerialnumber,
      equipmentName: equipmentData,
      category: categoryData,
      subCategory: subCategoryData,
      gatewayNo: gatewayNo,
      selectedDealerId: selectedDealerId,
    };
    filterSubmit(payload);
    fliterCloseDrawer();
  };

  return (
    <form
      onSubmit={handleSubmit(submitedData)}
      className="fliter-drawer-container"
    >
      <div>
        <div className="fliter-drawer-header">
          <p className="fliter-drawer-header-content">Fliters</p>
          {/* <p className="fliter-drawer-header-text">Restore</p> */}
        </div>

        <div className="fliter-drawer-body">
          <div className="fliter-drawer-body-content">
            <section className="fliter-drawer-serial-no">
              <div>
                <p className="fliter-drawer-body-lable">From Serial No</p>
                <TextField
                  variant="outlined"
                  placeholder="From Serial No"
                  fullWidth
                  type="number"
                  {...register('fromSerialnumber')}
                />
              </div>
              <div>
                <p className="fliter-drawer-body-lable">To Serial No</p>
                <TextField
                  variant="outlined"
                  placeholder="To Serial No"
                  fullWidth
                  type="number"
                  {...register('toSerialnumber')}
                />
              </div>
            </section>
          </div>
          {/* <div className="fliter-drawer-body-content">
            <section className="fliter-drawer-serial-no">
              <div>
                <p className="fliter-drawer-body-lable">From GateWay No</p>
                <TextField
                  variant="outlined"
                  placeholder="From GateWay No"
                  fullWidth
                  type='number'
                  {...register('fromGateWaynumber')}
                  // onChange={handleEquipmentSearch}
                />
              </div>
              <div>
                <p className="fliter-drawer-body-lable">To GateWay No</p>
                <TextField
                  variant="outlined"
                  placeholder="To GateWay No"
                  fullWidth
                  type='number'
                  {...register('toGateWaynumber')}
                  // onChange={handleEquipmentSearch}
                />
              </div>
            </section>
          </div> */}
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Equipment Type</p>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={equipmentData}
              onClose={() => setEquipmentFilter(inventoryFilterList?.equipment)}
              renderValue={() => {
                if (equipmentData?.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Equipment Type
                    </span>
                  );
                }
                return equipmentData?.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search  Equipment Type"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={(e) =>
                      handleSearch(
                        inventoryFilterList?.equipment,
                        e.target.value,
                        setEquipmentFilter,
                      )
                    }
                  />
                </div>
                <div className="selectoption_list_content">
                  {equipmentFilter?.map((equipment, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={equipmentData.includes(String(equipment))}
                            onChange={() => {
                              handleFilterSelection(
                                String(equipment),
                                setEquipment,
                              );
                            }}
                          />
                        }
                        label={equipment}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>

          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Category</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              value={categoryData}
              displayEmpty
              onClose={handleGetCategory}
              renderValue={() => {
                if (categoryData?.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Category
                    </span>
                  );
                }
                return categoryData?.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Category"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={(e) =>
                      handleSearch(
                        filterStoreCategory,
                        e.target.value,
                        setCategoryFilter,
                      )
                    }
                  />
                </div>
                <div className="selectoption_list_content">
                  {categoryFilter?.map((category, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={categoryData.includes(String(category))}
                            onChange={() => {
                              handleFilterSelection(
                                String(category),
                                setCategoryData,
                              );
                            }}
                          />
                        }
                        label={category}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Subcategory</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              disabled={subCategoryFilter?.length == 0}
              value={subCategoryData}
              onClose={handleGetSubCategory}
              renderValue={() => {
                if (subCategoryData.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Subcategory
                    </span>
                  );
                }
                return subCategoryData.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Subcategory"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={(e) =>
                      handleSearch(
                        filterStoreSubCategory,
                        e.target.value,
                        setSubCategoryFilter,
                      )
                    }
                  />
                </div>
                <div className="selectoption_list_content">
                  {subCategoryFilter?.map((subCategory, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={subCategoryData.includes(
                              String(subCategory),
                            )}
                            onChange={() => {
                              handleFilterSelection(
                                String(subCategory),
                                setSubCategoryData,
                              );
                            }}
                          />
                        }
                        label={subCategory}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          {userRole !== 'dealer' && (
            <>
              <div className="fliter-drawer-body-content">
                <p className="fliter-drawer-body-lable">Gateway Number</p>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  className="create_controller-nodata_drawer_form_field_input"
                  multiple
                  displayEmpty
                  value={gatewayNo}
                  onClose={() =>
                    setGatwayNoFilter(inventoryFilterList?.gatewayNo)
                  }
                  renderValue={() => {
                    if (gatewayNo.length === 0) {
                      return (
                        <span className="filter_dropdown_placeholder_text">
                          Gateway Number
                        </span>
                      );
                    }
                    return gatewayNo.join(', ');
                  }}
                  IconComponent={ExpandMore}
                >
                  <div className="selectoption_content filter_dropdown-height">
                    <div className="selectoption_search_content">
                      <TextField
                        className="selectoption_searchbar search-input"
                        variant="outlined"
                        placeholder="Search Gateway Number"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <SearchIcon className="search_icon" />
                          ),
                        }}
                        onChange={(e) =>
                          handleSearch(
                            inventoryFilterList?.gatewayNo,
                            e.target.value,
                            setGatwayNoFilter,
                          )
                        }
                      />
                    </div>
                    <div className="selectoption_list_content">
                      {gatwayNoFilter?.map((data, index) => (
                        <div key={index} className="selectoption_list">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={gatewayNo.includes(String(data))}
                                onChange={() => {
                                  handleFilterSelection(
                                    String(data),
                                    setGatewayNo,
                                  );
                                }}
                              />
                            }
                            label={data}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </Select>
              </div>

              {filterPage !== 'manufacturedUnit' && (
                <div className="fliter-drawer-body-content">
                  <p className="fliter-drawer-body-lable">Dealer</p>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    className="create_controller-nodata_drawer_form_field_input"
                    multiple
                    displayEmpty
                    value={selectedDealerId}
                    onClose={() => setFilteredData(allAssignDealerList)}
                    renderValue={() => {
                      if (selectedDealerId?.length === 0) {
                        return (
                          <span className="filter_dropdown_placeholder_text">
                            Dealer
                          </span>
                        );
                      }
                      return renderSelectedNames();
                    }}
                    IconComponent={ExpandMore}
                  >
                    <div className="selectoption_content filter_dropdown-height">
                      <div className="selectoption_search_content">
                        <TextField
                          className="selectoption_searchbar search-input"
                          variant="outlined"
                          placeholder="Search Gateway Number"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <SearchIcon className="search_icon" />
                            ),
                          }}
                          onChange={handleUserSearch}
                        />
                      </div>
                      <div className="selectoption_list_content">
                        {filteredData?.map((data, index) => (
                          <div key={index} className="selectoption_list">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedDealerId?.includes(
                                    data?.dealerID,
                                  )}
                                  onChange={() => handleuser(data)}
                                />
                              }
                              label={`${data?.firstName || ''} ${data?.lastName || ''}`}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </Select>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="create_controller-nodata_drawer_button_content">
        <div className="create_controller-nodata_drawer_button">
          <Button
            variant="text"
            className="cencel_button"
            onClick={fliterCloseDrawer}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            type="submit"
            className={
              isFilterActive ? 'save_button' : 'save_button disabled_button'
            }
            disabled={!isFilterActive}
          >
            Apply
          </Button>
        </div>
      </div>
    </form>
  );
};

const MemoizedComponent = React.memo(FilterDrawer);
export default MemoizedComponent;
